// extracted by mini-css-extract-plugin
export var alertIcon = "_ua-0";